
import { useFadeIn } from '../../../hooks/useFadeIn';

export default function WhiteningCta() {
  const heading = useFadeIn({ direction: 'up' });
  const body = useFadeIn({ direction: 'up', delay: 150 });
  const buttons = useFadeIn({ direction: 'up', delay: 250 });

  return (
    <section id="floating-cta-hide" className="py-32 px-6 lg:px-12 bg-gray-50">
      <div className="max-w-3xl mx-auto text-center">
        <div ref={heading.ref} style={heading.style}>
          <h2 className="text-2xl lg:text-3xl text-gray-900 mb-16 leading-relaxed font-serif">
            医療ホワイトニングと他のホワイトニングの違いなども丁寧にご説明いたします。<br />
            <span className="text-xl lg:text-2xl block mt-4">
              まずは一緒に最適なホワイトニングを見つけていきましょう。
            </span>
          </h2>
        </div>

        <div ref={body.ref} style={body.style}>
          <div className="space-y-8 text-gray-700 mb-20 text-left max-w-2xl mx-auto">
            <p>
              さいわいデンタルクリニックは<br />
              皆様にホワイトニングを検討する上での「判断軸」を提供することが大切にしています。まずは無料カウンセリングにてお気軽にご相談ください。
            </p>
          </div>
        </div>

        <div ref={buttons.ref} style={buttons.style}>
          <div className="flex flex-col items-center gap-4 max-w-xs mx-auto">
            <a
              href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-[#3E5F8F] hover:bg-[#344F78] text-white text-sm px-8 py-4 rounded-full transition-colors duration-300 whitespace-nowrap cursor-pointer shadow-sm w-full"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-calendar-line text-sm"></i>
              </span>
              WEB予約
            </a>
            <a
              href="tel:05018094594"
              className="flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-gray-800 text-sm px-8 py-4 rounded-full transition-colors duration-300 whitespace-nowrap cursor-pointer shadow-sm border border-gray-200 w-full"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-sm"></i>
              </span>
              電話で相談
            </a>
          </div>
          <p className="text-xs text-gray-500 mt-6">
            ※相談のみでも大丈夫です。<br />カウンセリングは無料です。
          </p>
        </div>
      </div>
    </section>
  );
}
